import axios from "axios";
import type {
  UpdateNextShipmentFillDateRequestProto_Body,
  UpdateNextShipmentFillDateResponseProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/medical_shipments_service";

import { HEALTHCARE_API } from "@modules/common/constants";

export const updateNextShipmentFillDate = async (
  accessCode: string,
  accessToken: string,
  body: UpdateNextShipmentFillDateRequestProto_Body,
  validateOnly: boolean = false,
  userTreatmentId?: string | null
): Promise<UpdateNextShipmentFillDateResponseProto> => {
  return (
    await axios.post<UpdateNextShipmentFillDateResponseProto>(
      `${HEALTHCARE_API}/v1/patient/${accessCode}/update_next_shipment_fill_date`,
      body,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
        params: {
          validateOnly,
          ...(userTreatmentId ? { user_treatment_id: userTreatmentId } : {}),
        },
      }
    )
  ).data;
};
